import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class TextosService 
{
    constructor(private http: HttpClient) { }

    obtieneTextos() 
    { 
        return this.http.get(`${environment.urlBase}/textos`, 
               { headers: this.armaCabecera() } ).toPromise(); 
    }
      

    armaCabecera()
    {
        return new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}